const INITIAL_FILTER_STATE = {
  end_period: null,
  created_on: '2024-09-09',
  created_on_operator: 'on-or-after',
  bz_validacao_backoffice: 2,
  bz_canal: 'Indicação',
  bz_origem: 'Indicação Cliente|Indicação Co-empreendedor',
};

const INITIAL_SORT_STATE = {
  created_on: 'ASC',
};

export { INITIAL_FILTER_STATE, INITIAL_SORT_STATE };
